export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6801.f44620aa.jpg";